import { useCallback, useMemo } from 'react';
import { toast } from 'react-toastify';
import { COMMON_ERROR_TEXT } from 'src/constants';

export const useErrorToast = () => {
  const onShowErrorToast = useCallback((text = COMMON_ERROR_TEXT) => {
    toast.error(text);
  }, []);

  return useMemo(
    () => ({
      onShowErrorToast,
    }),
    [onShowErrorToast],
  );
};
